/**
 * Detecta o país baseado no idioma e timezone do navegador
 * Prioriza locale (navigator.language) pois geralmente é mais preciso
 */
function detectCountry(): string | null {
  if (typeof navigator === 'undefined') return null
  
  try {
    // 1. PRIORIDADE: Tenta extrair código do país do locale (mais confiável)
    // Exemplos: 'pt-BR' -> 'BR', 'en-US' -> 'US', 'fr-FR' -> 'FR'
    const lang = navigator.language || navigator.languages?.[0] || ''
    if (lang) {
      const parts = lang.split('-')
      // Se tem código de país no locale (ex: pt-BR, en-US)
      if (parts.length > 1 && parts[1].length === 2) {
        const countryCode = parts[1].toUpperCase()
        // Valida que é um código válido (2 letras maiúsculas)
        if (/^[A-Z]{2}$/.test(countryCode)) {
          return countryCode
        }
      }
    }
    
    // 2. FALLBACK: Tenta detectar pelo timezone (expandido)
    if ('Intl' in globalThis) {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''
      if (tz) {
        // Mapeamento expandido de timezones para códigos de país
        const tzToCountry: Record<string, string> = {
          // América do Sul
          'America/Sao_Paulo': 'BR',
          'America/Manaus': 'BR',
          'America/Fortaleza': 'BR',
          'America/Recife': 'BR',
          'America/Campo_Grande': 'BR',
          'America/Cuiaba': 'BR',
          'America/Araguaina': 'BR',
          'America/Bahia': 'BR',
          'America/Belem': 'BR',
          'America/Boa_Vista': 'BR',
          'America/Maceio': 'BR',
          'America/Noronha': 'BR',
          'America/Porto_Velho': 'BR',
          'America/Rio_Branco': 'BR',
          'America/Santarem': 'BR',
          'America/Buenos_Aires': 'AR',
          'America/Argentina/Buenos_Aires': 'AR',
          'America/Cordoba': 'AR',
          'America/La_Paz': 'BO',
          'America/Santiago': 'CL',
          'America/Bogota': 'CO',
          'America/Guayaquil': 'EC',
          'America/Asuncion': 'PY',
          'America/Lima': 'PE',
          'America/Montevideo': 'UY',
          'America/Caracas': 'VE',
          
          // América do Norte
          'America/New_York': 'US',
          'America/Chicago': 'US',
          'America/Denver': 'US',
          'America/Los_Angeles': 'US',
          'America/Phoenix': 'US',
          'America/Anchorage': 'US',
          'America/Detroit': 'US',
          'America/Indiana/Indianapolis': 'US',
          'America/Juneau': 'US',
          'America/Kentucky/Louisville': 'US',
          'America/Menominee': 'US',
          'America/Metlakatla': 'US',
          'America/Nome': 'US',
          'America/North_Dakota/Center': 'US',
          'America/Sitka': 'US',
          'America/Yakutat': 'US',
          'America/Toronto': 'CA',
          'America/Vancouver': 'CA',
          'America/Winnipeg': 'CA',
          'America/Halifax': 'CA',
          'America/St_Johns': 'CA',
          'America/Mexico_City': 'MX',
          'America/Monterrey': 'MX',
          'America/Tijuana': 'MX',
          'America/Cancun': 'MX',
          'America/Merida': 'MX',
          'America/Chihuahua': 'MX',
          'America/Mazatlan': 'MX',
          'America/Hermosillo': 'MX',
          
          // Europa
          'Europe/London': 'GB',
          'Europe/Dublin': 'IE',
          'Europe/Lisbon': 'PT',
          'Europe/Madrid': 'ES',
          'Europe/Barcelona': 'ES',
          'Europe/Paris': 'FR',
          'Europe/Berlin': 'DE',
          'Europe/Munich': 'DE',
          'Europe/Rome': 'IT',
          'Europe/Milan': 'IT',
          'Europe/Amsterdam': 'NL',
          'Europe/Brussels': 'BE',
          'Europe/Vienna': 'AT',
          'Europe/Zurich': 'CH',
          'Europe/Stockholm': 'SE',
          'Europe/Oslo': 'NO',
          'Europe/Copenhagen': 'DK',
          'Europe/Helsinki': 'FI',
          'Europe/Warsaw': 'PL',
          'Europe/Prague': 'CZ',
          'Europe/Budapest': 'HU',
          'Europe/Bucharest': 'RO',
          'Europe/Sofia': 'BG',
          'Europe/Athens': 'GR',
          'Europe/Istanbul': 'TR',
          'Europe/Moscow': 'RU',
          'Europe/Kiev': 'UA',
          
          // Ásia
          'Asia/Tokyo': 'JP',
          'Asia/Seoul': 'KR',
          'Asia/Shanghai': 'CN',
          'Asia/Beijing': 'CN',
          'Asia/Hong_Kong': 'HK',
          'Asia/Macau': 'MO',
          'Asia/Taipei': 'TW',
          'Asia/Singapore': 'SG',
          'Asia/Kuala_Lumpur': 'MY',
          'Asia/Bangkok': 'TH',
          'Asia/Jakarta': 'ID',
          'Asia/Manila': 'PH',
          'Asia/Ho_Chi_Minh': 'VN',
          'Asia/Dubai': 'AE',
          'Asia/Riyadh': 'SA',
          'Asia/Jerusalem': 'IL',
          'Asia/Tehran': 'IR',
          'Asia/Baghdad': 'IQ',
          'Asia/Kuwait': 'KW',
          'Asia/Doha': 'QA',
          'Asia/Kolkata': 'IN',
          'Asia/Mumbai': 'IN',
          'Asia/Delhi': 'IN',
          'Asia/Dhaka': 'BD',
          'Asia/Karachi': 'PK',
          'Asia/Kathmandu': 'NP',
          'Asia/Colombo': 'LK',
          
          // Oceania
          'Australia/Sydney': 'AU',
          'Australia/Melbourne': 'AU',
          'Australia/Brisbane': 'AU',
          'Australia/Perth': 'AU',
          'Australia/Adelaide': 'AU',
          'Australia/Darwin': 'AU',
          'Australia/Hobart': 'AU',
          'Pacific/Auckland': 'NZ',
          'Pacific/Wellington': 'NZ',
          
          // África
          'Africa/Cairo': 'EG',
          'Africa/Johannesburg': 'ZA',
          'Africa/Casablanca': 'MA',
          'Africa/Lagos': 'NG',
          'Africa/Nairobi': 'KE',
          'Africa/Addis_Ababa': 'ET',
        }
        
        // Busca correspondência exata primeiro
        if (tzToCountry[tz]) {
          return tzToCountry[tz]
        }
        
        // Busca correspondência parcial pela região do timezone
        const tzParts = tz.split('/')
        if (tzParts.length > 1) {
          const tzRegion = tzParts[1]
          // Tenta encontrar correspondência parcial
          for (const [tzKey, country] of Object.entries(tzToCountry)) {
            const keyParts = tzKey.split('/')
            if (keyParts.length > 1 && (keyParts[1] === tzRegion || tzKey.includes(tzRegion))) {
              return country
            }
          }
        }
      }
    }
    
    // 3. ÚLTIMO FALLBACK: Mapeamento básico de idioma para país (menos confiável)
    if (lang) {
      const langCode = lang.split('-')[0].toLowerCase()
      const langToCountry: Record<string, string> = {
        'pt': 'BR', // Português -> Brasil (mais comum)
        'en': 'US', // Inglês -> EUA (mais comum)
        'es': 'ES', // Espanhol -> Espanha
        'fr': 'FR', // Francês -> França
        'de': 'DE', // Alemão -> Alemanha
        'it': 'IT', // Italiano -> Itália
        'ja': 'JP', // Japonês -> Japão
        'zh': 'CN', // Chinês -> China
        'ko': 'KR', // Coreano -> Coreia do Sul
        'ru': 'RU', // Russo -> Rússia
        'ar': 'SA', // Árabe -> Arábia Saudita
        'tr': 'TR', // Turco -> Turquia
        'pl': 'PL', // Polonês -> Polônia
        'nl': 'NL', // Holandês -> Holanda
        'sv': 'SE', // Sueco -> Suécia
        'no': 'NO', // Norueguês -> Noruega
        'da': 'DK', // Dinamarquês -> Dinamarca
        'fi': 'FI', // Finlandês -> Finlândia
        'el': 'GR', // Grego -> Grécia
        'he': 'IL', // Hebraico -> Israel
        'hi': 'IN', // Hindi -> Índia
        'th': 'TH', // Tailandês -> Tailândia
        'vi': 'VN', // Vietnamita -> Vietnã
        'id': 'ID', // Indonésio -> Indonésia
        'ms': 'MY', // Malaio -> Malásia
        'cs': 'CZ', // Tcheco -> República Tcheca
        'hu': 'HU', // Húngaro -> Hungria
        'ro': 'RO', // Romeno -> Romênia
        'bg': 'BG', // Búlgaro -> Bulgária
        'uk': 'UA', // Ucraniano -> Ucrânia
        'sk': 'SK', // Eslovaco -> Eslováquia
        'sr': 'RS', // Sérvio -> Sérvia
      }
      
      if (langToCountry[langCode]) {
        return langToCountry[langCode]
      }
    }
  } catch (error) {
    // Silenciosamente falha na detecção
  }
  
  return null
}

export async function postJSON(url: string, body: unknown, debug = false, headers?: Record<string, string>): Promise<boolean> {
  // SEMPRE usa fetch quando headers foi passado (mesmo que vazio)
  // sendBeacon NÃO suporta headers customizados, então nunca usamos quando precisamos de headers
  const hasHeaders = headers !== undefined
  
  // Só usa sendBeacon se NÃO tiver headers E sendBeacon estiver disponível
  if (!hasHeaders && typeof navigator !== 'undefined' && 'sendBeacon' in navigator) {
    try {
      // usa text/plain para ser "simple request" e evitar preflight
      const ok = navigator.sendBeacon(
        url,
        new Blob([JSON.stringify(body)], { type: 'text/plain' })
      )
      return ok
    } catch (error) {
      // Fallback para fetch se sendBeacon falhar
    }
  }

  // SEMPRE usa fetch quando headers foi passado ou como fallback
  try {
    const fetchHeaders: Record<string, string> = { 'Content-Type': 'text/plain' }
    if (headers && Object.keys(headers).length > 0) {
      Object.assign(fetchHeaders, headers)
    }
    
    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: fetchHeaders,
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
    })
    
    return res.ok
  } catch (error) {
    return false
  }
}

export { detectCountry }
